export class AppConstants {
    public static get baseURL(): string { return "http://localhost:47695/"; }
    
    public static get isCaptcha(): boolean { return true; }

}
//http://localhost:47695/
//https://test-app01.cne.gob.ec/CneApiWs/
